<script lang="ts">
  import type { Snippet } from 'svelte';

  let {
    title,
    subtitle,
    padded = true,
    class: className = '',
    actions,
    children,
  }: {
    title?: string;
    subtitle?: string;
    padded?: boolean;
    class?: string;
    actions?: Snippet;
    children: Snippet;
  } = $props();
</script>

<section class="card {className}">
  {#if title || actions}
    <header class="card-head">
      <div>
        {#if title}
          <h3>{title}</h3>
        {/if}
        {#if subtitle}
          <p class="secondary">{subtitle}</p>
        {/if}
      </div>
      {#if actions}
        <div class="card-actions">{@render actions()}</div>
      {/if}
    </header>
  {/if}
  <div class="card-body" class:no-pad={!padded} class:no-head={!(title || actions)}>
    {@render children()}
  </div>
</section>

<style>
  .card {
    background: color-mix(in srgb, var(--bg-elevated) 88%, transparent);
    border: 1px solid var(--border);
    border-radius: var(--radius-xl);
    box-shadow: var(--shadow-sm);
    backdrop-filter: blur(10px);
  }

  /* Header keeps its padding regardless of `padded` — only the body (table
     content) goes edge-to-edge when a page opts out. Otherwise a title like
     "Client list" ends up flush against the card border. */
  .card-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: var(--space-4);
    padding: var(--space-5) var(--space-5) 0;
    margin-bottom: var(--space-4);
  }

  .card-head h3 {
    font-size: var(--text-lg);
  }

  .card-head p {
    margin-top: var(--space-1);
    font-size: var(--text-sm);
  }

  .card-actions {
    display: flex;
    gap: var(--space-2);
    flex-shrink: 0;
  }

  .card-body {
    min-width: 0;
    padding: 0 var(--space-5) var(--space-5);
  }

  /* No header above it — body needs its own top padding too. */
  .card-body.no-head {
    padding-top: var(--space-5);
  }

  .card-body.no-pad {
    padding: 0;
  }
</style>
